import getConfig from 'next/config';
import { useRouter } from 'next/router';
import React from 'react';

import { CommonHead } from '@sravni/next-common-head';
import { useTheme } from '@sravni/react-utils';

import { AB_NAME } from '../../constants/sitesettings';

const { webPath } = getConfig().publicRuntimeConfig;

interface IProps {
  subId: string;
  routeForIOSSmartBanner: boolean;
}

export const CommonHeadComponent = ({ subId, routeForIOSSmartBanner }: IProps) => {
  const { asPath } = useRouter();
  const [theme] = useTheme();

  return (
    <CommonHead
      analyticsOptions={{
        enabled: true,
        googleTmId: 'GTM-PMDFG9',
        ab: AB_NAME,
        userId: subId,
        theme,
        yandexMetricsOptions: {},
      }}
    >
      {routeForIOSSmartBanner && (
        <meta name="apple-itunes-app" content={`app-id=1449578663, app-argument=${webPath}${asPath}`} />
      )}
    </CommonHead>
  );
};
